import React, { useEffect, useState, useRef } from 'react';
import { Quote, Star } from 'lucide-react';
import { testimonials } from '../data/mockData';

const TestimonialsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const doubled = [...testimonials, ...testimonials];

  return (
    <section ref={ref} id="depoimentos" className="py-20 md:py-28 bg-[#111111] overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
          }`}
        >
          <span className="font-body text-xs tracking-[0.3em] uppercase text-[#C9A961]">Depoimentos</span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-white mt-3 mb-4">
            O que dizem sobre nós
          </h2>
          <div className="w-12 h-[2px] bg-gradient-to-r from-[#8B6F47] to-[#C9A961] mx-auto mt-6" />
        </div>
      </div>

      <div className="relative">
        <div className="flex animate-scroll-left" style={{ width: 'max-content' }}>
          {doubled.map((t, i) => (
            <div
              key={i}
              className="w-[320px] flex-shrink-0 mx-3 p-6 rounded-sm border border-white/10 bg-white/[0.03] hover:border-[#8B6F47]/40 transition-all duration-300"
            >
              <Quote className="w-7 h-7 text-[#8B6F47]/30 mb-4" />
              <p className="font-body text-sm text-white/70 mb-5 italic leading-relaxed min-h-[60px]">
                "{t.text}"
              </p>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 text-[#C9A961] fill-[#C9A961]" />
                ))}
              </div>
              <p className="font-display text-base text-[#C9A961]">{t.name}</p>
              <p className="font-body text-xs text-white/40">{t.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
